import axios from "@/plugins/axios";

let url = "/api/v1/setting";

export default {
    get(){
        return axios.get(url).then(result => result.data);
    },
}
